module.exports = __webpack_public_path__ + "img/01.bff94c5f.png";